import React, { useEffect, useState } from 'react';
import { useFindStatusChangeByDispatchBoardQuery } from 'reducers/statusChange/api';
import { goBack, push } from 'connected-react-router';
import { useErrorHandler } from 'common_components/ErrorContext';
import { PageHeader, Divider, Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import Form from './Form';
import permission from 'permissions';
import { getCurrentUser } from 'reducers/user';
import { useSelector, useDispatch } from 'react-redux';
import { setSidebarVisibility } from 'reducers/ui';

const StatusChangeDetailComponent = (props) => {
  const [readonly, setReadonly] = useState(false);
  const dispatch = useDispatch();
  const { id_param } = useParams();
  const user = useSelector(getCurrentUser);
  const { setErrorData } = useErrorHandler();

  const { data, error, isLoading } = useFindStatusChangeByDispatchBoardQuery(
    id_param,
    {
      skip: !id_param,
    }
  );

  useEffect(() => {
    dispatch(setSidebarVisibility(false));
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      if (!permission.checkPermission(user, 'create_trip')) {
        message.error('Permission denied');
        dispatch(goBack());
      } else {
        if (!permission.checkPermission(user, 'create_trip', ['u'])) {
          setReadonly(true);
        } else {
          setReadonly(false);
        }
      }
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (error) {
      setErrorData(error);
      if (error.data.errorList[0].errorDetail === 'Not found dispatch board.') {
        setTimeout(() => {
          dispatch(push(`/app/delivery_mng/lists`));
        }, 2000);
      }
    }
  }, [dispatch, error, setErrorData]);

  return (
    <Container>
      <StyledPageHeader
        ghost={false}
        onBack={() => dispatch(goBack())}
        title='Status Change'
        subTitle=''
      />
      <Divider style={{ margin: 0 }} />
      <Content>
        {isLoading === true ? (
          <RootCircular>
            <CenterSpin indicator={antIcon} size='large' />
          </RootCircular>
        ) : (
          <Form
            formData={data || null}
            isCreate={!id_param}
            readonly={id_param ? readonly : false}
          />
        )}
      </Content>
    </Container>
  );
};
const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const StyledPageHeader = styled(PageHeader)`
  padding: 0px 10px;
`;

const Container = styled.div`
  height: calc(100%);
  padding: 10px;
`;

const Content = styled.div`
  background: white;
  height: calc(100% - 42px);
  overflow: auto;
`;

const RootCircular = styled.div`
  display: table;
  height: calc(100%);
  margin: auto;
`;
const CenterSpin = styled(Spin)`
  display: table-cell;
  vertical-align: middle;
`;

export default StatusChangeDetailComponent;
